import { Component, OnInit } from '@angular/core';
import { CartState } from '@app/store/state/cart.state';
import { CartHasKsuiteParam } from '@app/order/recommendation/new-domain-recommendation/helpers/ksuite.helper';
import { Store } from '@ngxs/store';

export const TUNNELS = {
  KSUITE: 'ksuite',
  CLASSIC: 'classic',
};

export type Ttunnels = typeof TUNNELS[keyof typeof TUNNELS];

@Component({
  selector: 'app-signup-right-block',
  templateUrl: './signup-right-block.component.html',
  styleUrls: ['./signup-right-block.component.scss']
})
export class SignupRightBlockComponent implements OnInit {
  TUNNELS = TUNNELS;

  currentTunnel: Ttunnels;


  constructor(private store: Store) {

  }

  ngOnInit(): void {
    const cart = this.store.selectSnapshot(CartState.getCart);
    const cartHasKsuiteSummary = cart.summary?.find(item => item.type === 'ksuite')?.type === 'ksuite';

    if (cart && (CartHasKsuiteParam(cart?.attributes) || cartHasKsuiteSummary)) {
      this.currentTunnel = TUNNELS.KSUITE;
    } else {
      this.currentTunnel = TUNNELS.CLASSIC;
    }
  }
}
